import { Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'eui-toolbar-item-notifications',
    templateUrl: './toolbar-item-notifications.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiToolbarItemNotificationsComponent {

    @HostBinding('class') string = 'eui-toolbar-item-notifications';

    constructor(
    ) {
    }
}
